var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiquidationServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H52C56.4183 0 60 3.58172 60 8V52C60 56.4183 56.4183 60 52 60H8C3.58172 60 0 56.4183 0 52V8Z",
    fill: "url(#paint0_linear_182_222)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.469 14.418L35.355 25.7343L46.5368 30.6785L35.3536 35.6226L30.4676 46.9404L25.5816 35.6226L14.3984 30.6785L25.5816 25.7343L30.469 14.418ZM43.4946 19.1256L41.2994 20.2306L43.4946 21.337L44.588 23.5611L45.6814 21.337L47.8794 20.232L45.6814 19.1256L44.5894 16.9014L43.4946 19.1256ZM30.469 21.4956L27.711 27.8862L21.3942 30.6785L27.7096 33.4707L30.469 39.8627L33.2284 33.4707L39.5452 30.6799L33.2284 27.8862L30.469 21.4956ZM40.7114 35.3195L42.5314 39.017L46.1854 40.8586L42.5314 42.6989L40.7114 46.3964L38.8914 42.6989L35.2374 40.8572L38.8914 39.017L40.7114 35.3195Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_182_222",
    x1: 30,
    y1: 0,
    x2: 30,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3896BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A4558"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidationServices);
export default __webpack_public_path__ + "static/media/LiquidationServices.1ddc895a507b12e126db26cfc9b2bddb.svg";
export { ForwardRef as ReactComponent };